import styled, { css } from 'styled-components';
import { optionHover } from '../../styles/shareableStyles';
import { theme } from '../../styles/theme';

export const LinkContainer = styled.div<{ $isDisabled?: boolean }>`
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    pointer-events: none;
    opacity: 0.5;
  `};
`;

export const TruncatedBlock = styled.div`
  max-width: 100%;
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const StyledNavItem = styled.div<{
  $isInteractive?: boolean;
  $isDisabled?: boolean;
}>`
  display: flex;
  align-items: center;
  column-gap: 8px;
  height: 32px;
  padding-right: 4px;
  padding-left: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.5;
      pointer-events: auto;
    `};
  ${({ $isInteractive }) =>
    $isInteractive &&
    css`
      border-radius: 4px;
      color: ${theme.colors.secondary800};
      transition:
        background 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
        color 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
      .isHovered &,
      .active &,
      &.active,
      &:hover {
        cursor: pointer;
        ${optionHover};
      }
    `}
`;
